import { useQuery } from '@tanstack/react-query';
import { usePurchasingApi } from '../../../purchases/hooks/use-purchasing-api';

const QK_CURRENT_ORDER_COUNT = ['current-order-count'] as const;

export function useCurrentOrderCount() {
  const { purchasingApi } = usePurchasingApi();

  return useQuery<number>({
    queryKey: QK_CURRENT_ORDER_COUNT,
    queryFn: async () => {
      const lte = new Date();
      const gte = new Date(lte.getTime() - 30 * 24 * 60 * 60 * 1000);

      const purchaseCounts = await purchasingApi.getPurchaseCounts({
        dates: { submitted: { lte: lte, gte: gte } },
      });

      return purchaseCounts.reduce((acc, cur) => acc + cur.count, 0);
    },
  });
}
